// import React from "react";

// import { Icon } from "~/components/atoms/Icons";
// import { EIcon } from "~/utilities/enums/Icons";

// interface ButtonShowflatButtonProps {
//   onClick: () => void;
// }

// const FloatingShowflatButton: React.FC<ButtonShowflatButtonProps> = ({
//   onClick,
// }) => {
//   return (
//     <button className="items-center justify-start" onClick={onClick}>
//       <Icon
//         TypeIcon={EIcon.Phone}
//         width={28}
//         height={28}
//         className=":hover-bg-opacity-100 fixed right-6 z-[40] mb-[100px] h-[56px] w-[56px] translate-x-px rounded-full bg-contactUsButtonIcon shadow-phone-floating-button hover:bg-opacity-100"
//       />
//     </button>
//   );
// };

// export default FloatingShowflatButton;

import { useLocation, useRouteLoaderData } from "@remix-run/react";
import React from "react";

import { Icon } from "~/components/atoms/Icons";
import useAppState from "~/stores";
import { IRouteLoaderData } from "~/types/routeLoaderData";
import { cn } from "~/utilities/cn";
import { PATH_NAME } from "~/utilities/constants/pathname";
import { EIcon } from "~/utilities/enums/Icons";

interface ButtonShowflatButtonProps {
  onClick: () => void;
}

const FloatingShowflatButton: React.FC<ButtonShowflatButtonProps> = ({
  onClick,
}) => {
  const { locale } = useRouteLoaderData("root") as IRouteLoaderData;
  const { showComparedProjectsBar, comparedProjects } = useAppState(
    (state) => state
  );
  const location = useLocation();
  return (
    <div
      className={cn(
        "fixed right-6 z-[40] flex flex-col items-end gap-3",
        comparedProjects.length > 0 &&
          showComparedProjectsBar &&
          PATH_NAME.COMPARE_PROJECTS.all(locale || "") !== location?.pathname
          ? "bottom-[150px] lg:bottom-[170px]"
          : "bottom-[24px]"
      )}
    >
      <button className="items-center justify-start" onClick={onClick}>
        <Icon
          TypeIcon={EIcon.LightBulbIcon}
          width={40}
          height={40}
          className=" :hover-bg-opacity-100 text-showflatButtonIcon border-showflatButtonIcon h-[56px] w-[56px] translate-x-px rounded-full border border bg-white hover:bg-opacity-100"
        />
      </button>
    </div>
  );
};

export default FloatingShowflatButton;
